import { HttpMethods } from '@codametrix/ui-common';
import actionCreatorFactory from 'typescript-fsa';
import asyncFactory from 'typescript-fsa-redux-thunk';
import { api } from '../core/net';

const actionCreator = actionCreatorFactory();
const createAsync = asyncFactory<any>(actionCreator);

interface ListConfigurationsPayload {
  tenantId: string;
}

interface UpdateConfigurationValuePayload {
  configurationId: number;
  tenantId: string;
  configValue: CMxAPI.ConfigurationValue;
}

export const updateConfigurationValue = createAsync<
  UpdateConfigurationValuePayload,
  CMxAPI.ConfigurationValue,
  any
>('UPDATE_CONFIGURATION_VALUE', async (payload, dispatch) => {
  const { configurationId, tenantId, configValue } = payload;

  return await api(
    {
      endpoint: `/configuration/detail/updateValue/${configurationId}/${tenantId}/v2`,
      init: {
        method: HttpMethods.PUT,
        body: JSON.stringify(configValue)
      }
    },
    true,
    true
  );
});

export const listConfigurations = createAsync<
  ListConfigurationsPayload,
  any,
  any
>('LIST_CONFIGURATIONS', async (payload, dispatch) => {
  const { tenantId } = payload;
  return await api({
    endpoint: `/configuration/listAllConfigurationByTenantId/${tenantId}/v2?includeEmptyConfigurations=true`,
    init: {
      method: HttpMethods.GET
    }
  });
});

interface FetchConfigDetailPayload {
  configurationId: string | number;
  tenantId: string;
}

export const fetchConfigDetail = createAsync<
  FetchConfigDetailPayload,
  any,
  any
>('FETCH_CONFIG_DETAIL', async (payload, dispatch) => {
  const { configurationId, tenantId } = payload;
  return await api({
    endpoint: `/configuration/detail/${configurationId}/${tenantId}/v2?includeEmptyConfigurations=true`,
    init: {
      method: HttpMethods.GET
    }
  });
});

export const toggleConfigDrawer = actionCreator<boolean>(
  'TOGGLE_CONFIG_DRAWER'
);
export const toggleConfigDrawerContent = actionCreator<boolean>(
  'TOGGLE_CONFIG_DRAWER_CONTENT'
);

interface FetchConfigurationAuditPayload {
  tenantId: string;
  pageNumber?: number;
  pageSize?: number;
  serviceLine?: string;
  searchKey?: string;
}

export const fetchConfigurationAudit = createAsync<
  FetchConfigurationAuditPayload,
  CMxAPI.PageableList<CMxAPI.ConfigurationAuditEntry>,
  any
>(
  'FETCH_CONFIGURATION_AUDIT',
  async ({ tenantId, pageNumber, pageSize, serviceLine, searchKey }) => {
    const params = new URLSearchParams({
      tenantId,
      pageNumber: pageNumber?.toString() || '1',
      pageSize: pageSize?.toString() || '20'
    });

    if (serviceLine) {
      params.append('serviceLine', serviceLine);
    }

    if (searchKey) {
      params.append('searchKey', searchKey);
    }

    return await api({
      endpoint: `/configuration/audit/configurationsValues?${params.toString()}`,
      init: {
        method: HttpMethods.GET
      }
    });
  }
);
